import { ref,reactive, computed, onMounted, watch, provide } from "vue";
import { getActiveDetail, getShopGoodsList,searchByBrandAndCategory ,getShopGoodsFilterList} from "~/api";
import { useRoute, useState } from "#app";
 
import { get } from "lodash-es";
import { makeAllArcListMap, filterTreeConf } from "~/utils/asyncData";
import { useMainStore } from "~/composables/store";
import { parseSiteConfigData, resolveSiteDisplayTitle } from "@/utils/siteSeo";

function createEmptyActiveDetailData() {
  return {
    currentPageConfig: null,
    pages: [],
    allArcListMap: {},
    allGoodsListMap: {},
  };
}

function withDevelopmentTimeout(promise, timeoutMs = 6000) {
  if (process.env.NODE_ENV !== "development") {
    return promise;
  }

  return Promise.race([
    promise,
    new Promise((_, reject) => {
      setTimeout(() => {
        reject(new Error(`Development request timeout after ${timeoutMs}ms`));
      }, timeoutMs);
    }),
  ]);
}

export default function pageEditorUse(
  { activeDetailData, currentPageIndex },
  { isPage, isMobile }
) {
  const store = useMainStore();
  const route = useRoute();

  const edit = ref(
    (route.path && route.path.indexOf("/preview") >= 0) || false
  );
  const isEnterCtrl = ref(false);
  const langJsonState= reactive({
    langJsonConfigMap:{}
  })

  

  // provide('getActiveDetail_allArcListMap', () => {
  //   return {
  //     langJson: activeDetailData.allArcListMap || {},
  //   };
  // });

  if (isPage) {
    // 设置页面标题
    const siteInfo = store.getSiteInfo();
    const configData = parseSiteConfigData(siteInfo?.configData);
    const siteTitle = resolveSiteDisplayTitle(siteInfo);

    if (siteTitle) {
      useHead({
        title: siteTitle,
      });
    }
    // 设置站点图标（优先 SITE_ICON，带兜底）
    const siteIcon =
    configData?.SITE_ICON ||
    configData?.pc_SITE_ICON ||
    configData?.favicon ||
    configData?.icon ||
    configData?.logoUrl;

    if (siteIcon) {
      useHead({
        link: [
          { rel: "icon", type: "image/png", href: siteIcon },
          { rel: "shortcut icon", href: siteIcon },
          { rel: "apple-touch-icon", href: siteIcon },
        ],
      });
    }
    useHead({
      meta: [
        { charset: "utf-8" },
        {
          hid: "viewport",
          name: "viewport",
          content: "width=device-width, initial-scale=1, viewport-fit=cover",
        },
      ],
    });
  }

  // 监听键盘事件
  const onkeydownFunc = (e) => {
    let e1 = e || event || window.event || arguments.callee.caller.arguments[0];
    if (e1.keyCode == 17) {
      console.log("lock");
      isEnterCtrl.value = true;
    }
  };

  const onkeyupFunc = (e) => {
    let e1 = e || event || window.event || arguments.callee.caller.arguments[0];
    if (e1.keyCode == 17) {
      console.log("unlock");
      isEnterCtrl.value = false;
    }
  };

  // 右键菜单处理
  const onContextmenu = (event) => {
    if (!process.client) {
      return;
    }
    if (!edit.value) return;
    event.preventDefault();

    if (route.path.indexOf("site") >= 0) return;

    let findLevelIdxs = "";
    let findItem = null;

    if (window.$(event.target).attr("data-target-level-keys")) {
      findItem = window.$(event.target);
      findLevelIdxs = window.$(event.target).attr("data-target-level-keys");
    } else if (
      window.$(event.target).parents("[data-target-level-keys]").size()
    ) {
      findItem = window
        .$(event.target)
        .parents("[data-target-level-keys]")
        .eq(0);
      findLevelIdxs = findItem.attr("data-target-level-keys");
    }
    if (!findLevelIdxs) return true;
    selectElement(findLevelIdxs.split("x"));
    if (isEnterCtrl.value) return;

    const componentNameMap = {
      Col: "栅格列",
      Row: "栅格行",
      Banner: "轮播图",
      TextItem: "文字",
      HtmlItem: "富文本",
      ImageItem: "图片",
      CommonComponentsItem: "公用模板组件",
      TabsItem: "tabs分类",
    };
    const componentName = findItem.attr("data-component-name");

    // 示例代码，假设使用vue-contextmenu.js
    // 需要根据具体实现调整
    if (typeof contextmenu != "undefined") {
      contextmenu({
        items: [
          {
            label: `${
              componentNameMap[componentName] || componentName
            }(${findLevelIdxs})`,
            divided: true,
            disabled: true,
            icon: "el-icon-menu",
          },
          {
            label: "上移",
            disabled: findItem.dataset.canMoveUp === "false",
            onClick: () => moveElementUp(findLevelIdxs.split("x")),
          },
          {
            label: "下移",
            disabled: findItem.dataset.canMoveDown === "false",
            onClick: () => moveElementDown(findLevelIdxs.split("x")),
          },
          {
            label: "复制",
            onClick: () => copyElement(findLevelIdxs.split("x")),
          },
          {
            label: "删除",
            onClick: () => removeElement(findLevelIdxs.split("x")),
          },
        ],
        event,
        customClass: "custom-class",
        zIndex: 3,
        minWidth: 230,
      });
    }

    return false;
  };

  // 刷新页面
  const eventToSetRenderData = (event) => {
    if (typeof event.data !== "string") return;

    const setData = event.data.split("-*-*-");
    if (setData[0] === "setPagesData") {
      try {
        let setPagesData = JSON.parse(setData[1]);
        setPagesData = setPagesData || [];
        if (!activeDetailData.value) {
          activeDetailData.value = createEmptyActiveDetailData();
        }
        activeDetailData.value.currentPageConfig =
          setPagesData[currentPageIndex.value];
        activeDetailData.value.pages = setPagesData || [];
      } catch (e) {
        console.error(e);
      }
    } else if (event.data.indexOf("setPagesSelectIdxData-") == 0) {
      const setIdx = event.data.split("-")[1].split("x");
      currentElementIndex.value = setIdx;
    } else if (event.data.indexOf("setPagesIdxData-") == 0) {
      const setIdx = event.data.split("-")[1];
      currentPageIndex.value = setIdx;
    } else if (event.data.indexOf("getLangJsonMap") == 0) {
      console.log(
        "this.langJsonMap",
        langJsonState.langJsonConfigMap
      );
      if (typeof top != "undefined")
        top.postMessage(
          "langJsonMap-*_*_*-" +
            JSON.stringify(langJsonState.langJsonConfigMap),
          "*"
        );
      if (typeof parent != "undefined"&& top != parent )
        parent.postMessage(
          "langJsonMap-*_*_*-" +
            JSON.stringify(langJsonState.langJsonConfigMap),
          "*"
        );
    }
  };

  // 元素选择
  const selectElement = (idx) => {
    currentElementIndex.value = idx;
    top.postMessage("selectPcElement-" + idx.join("x"), "*");
    if (typeof parent != "undefined" && parent != top)
      parent.postMessage("selectPcElement-" + idx.join("x"), "*");
  };

  // 删除元素
  const removeElement = (idx) => {
    top.postMessage("removePcElement-" + idx.join("x"), "*");
    if (typeof parent != "undefined" && parent != top)
      parent.postMessage("removePcElement-" + idx.join("x"), "*");
  };

  // 复制元素
  const copyElement = (idx) => {
    top.postMessage("copyPcElement-" + idx.join("x"), "*");
    if (typeof parent != "undefined" && parent != top)
      parent.postMessage("copyPcElement-" + idx.join("x"), "*");
  };

  // 元素上移
  const moveElementUp = (idx) => {
    top.postMessage("movePcElementUp-" + idx.join("x"), "*");
    if (typeof parent != "undefined" && parent != top)
      parent.postMessage("movePcElementUp-" + idx.join("x"), "*");
  };

  // 元素下移
  const moveElementDown = (idx) => {
    top.postMessage("movePcElementDown-" + idx.join("x"), "*");
    if (typeof parent != "undefined" && parent != top)
      parent.postMessage("movePcElementDown-" + idx.join("x"), "*");
  };

  onMounted(() => {
    if (process.client && edit.value) {
      window.addEventListener("message", eventToSetRenderData, false);
      document.addEventListener("keydown", onkeydownFunc);
      document.addEventListener("keyup", onkeyupFunc);
    }
  });

  onBeforeUnmount(() => {
    if (process.client && edit.value) {
      window.removeEventListener("message", eventToSetRenderData, false);
      document.removeEventListener("keydown", onkeydownFunc);
      document.removeEventListener("keyup", onkeyupFunc);
    }
  });
 
  setPageHeaderStyleConfig(activeDetailData.value);

  const currentElementIndex = ref([0]);
  // 获取页面元素索引
  const currentElementIndexStr = computed(() => {
    return currentElementIndex.value.join("x");
  });

  function getConfigJsonHook() {
    const currentPageConfig = activeDetailData.value?.currentPageConfig || {};
    return {
      langJson: currentPageConfig.langJson || {},
      bindData: currentPageConfig.bindData || {},
      isPreview: edit.value,
    };
  }
  function setLangJsonConfigMapHook(key,value) {
   
    if (!langJsonState.langJsonConfigMap) langJsonState.langJsonConfigMap = { };
    langJsonState.langJsonConfigMap[key] = value||true;
    return {
      langJson: langJsonState.langJsonConfigMap || {},
    };
  }
  return {
    langJsonState,
    setLangJsonConfigMapHook,
    getConfigJsonHook,
    currentElementIndex,
    currentElementIndexStr,
    edit,
    onContextmenu,
  };
}
export function setPageHeaderStyleConfig(activeDetailData){
  if (activeDetailData&&activeDetailData.currentPageConfig) {
    if (get(activeDetailData, "currentPageConfig.info.cssText", "")) {
      useHead({
        style: [
          {
            body: true,
            innerHTML: get(
              activeDetailData,
              "currentPageConfig.info.cssText",
              ""
            ),
          },
        ],
      });
    }
    if (
      process.client &&
      get(activeDetailData, "currentPageConfig.info.javascriptText", "")
    ) {
      useHead({
        script: [
          {
            type: "text/javascript",

            body: true,
            innerHTML: get(
              activeDetailData,
              "currentPageConfig.info.javascriptText",
              ""
            ),
          },
        ],
      });
    }
  }
}

export function filterGoodsListData(pages) {
  let nowConfigs = pages[0].elements;
  let configList = filterTreeConf(nowConfigs, [], ["shopGoodsList"]);
  let requestMap = {};
  configList.map((item) => {
    // 使用请求参数组合作为key，而不是lvKey
    const requestKey = JSON.stringify({
      pageSize: item.conf.isShowLength || 10,
      pageNo: 0,
      platformType: item.conf.platformType || "shop",
      mergeFetchData: item.conf.mergeFetchData || "{}",
      defaultCategorys: item.conf.defaultCategorys || "",
      categoryTitle: item.conf.categoryTitle || null,
    });
    
    requestMap[requestKey] = {
      pageSize: item.conf.isShowLength || 10,
      pageNo: 0,
      platformType: item.conf.platformType || "shop",
      mergeFetchData: item.conf.mergeFetchData || "{}",
      defaultCategorys: item.conf.defaultCategorys || "",
      categoryTitle: item.conf.categoryTitle || null,
      lvKey: item.lvKey, // 保留lvKey用于组件识别
    };
  });

  return requestMap;
}

export function makeAllGoodsListMap($fetch, headers, pages, allGoodsListMap) {
  return new Promise(async (resolve, reject) => {
    if (pages && pages.length > 0) {
      let requestMap = filterGoodsListData(pages);
      let requestList = [];
      let requestParamsList = [];
      
      Object.keys(requestMap).map((key) => {
        requestList.push(key);
        requestParamsList.push(requestMap[key]);
      });

      let resAllGoodsListData = null;
      if (requestParamsList.length) {
        try {
          // 并行请求所有商品列表数据
          const promises = requestParamsList.map(async (params) => {
            try {
              let mergeData = {};
              try {
                mergeData = JSON.parse(params.mergeFetchData);
              } catch (e) {
                console.log(e);
              }
              
              let responseData =null;
              if(params.platformType == "shop"){
                responseData = await getShopGoodsList({
                  param: {
                    pageSize: params.pageSize,
                    pageNo: params.pageNo,
                    categoryTitle:params.categoryTitle||null,
                    ...mergeData,
                  }
                }, $fetch, headers);
              }else if(params.platformType == "shopListByBrandAndCategory"){
                responseData = await getShopGoodsFilterList({
                  param: {
                    pageSize: params.pageSize,
                    pageNo: params.pageNo,
                    ...mergeData,
                  }
                }, $fetch, headers);
              }


              
              
              // 应用数据过滤器
              if (!get(responseData, "data.dataList") && get(responseData, "data.data")) {
                responseData.data.dataList = get(responseData, "data.data");
              }
              if (
                !get(responseData, "data.totalRecord") &&
                get(responseData, "data.totalRecords")
              ) {
                responseData.data.totalRecord = get(responseData, "data.totalRecords");
              }
              
              return responseData;
            } catch (e) {
              console.error("获取商品列表失败:", e);
              return { data: { dataList: [], totalRecord: 0 } };
            }
          });
          
          resAllGoodsListData = await Promise.all(promises);
        } catch (e) {
          console.error("批量获取商品列表失败:", e);
          resAllGoodsListData = [];
        }
      }
      
      if (resAllGoodsListData && resAllGoodsListData.length > 0) {
        resAllGoodsListData.map((o, i) => {
          const requestKey = requestList[i];
          // 直接使用请求参数作为key存储数据
          allGoodsListMap[requestKey] =
            o && o.data && o.data.dataList ? o.data : { dataList: [], totalRecord: 0 };
        });
      }
    }
    resolve({ allGoodsListMap });
  });
}

export function getActiveDetailDataAsync(
  { $fetch, headers, id, url },
  { currentPageIndex }
) {
 
  const route = useRoute();

  
  return new Promise(async (resolve, reject) => {
    let resAll = {};

    // 动态设置页面的 title 和 description
    const store = useMainStore();
    const siteInfo = store.getSiteInfo();
    
    if (siteInfo) {
      const configData = parseSiteConfigData(siteInfo?.configData);
      const siteTitle = resolveSiteDisplayTitle(siteInfo);

      // 设置页面标题
      if (siteTitle) {
        useHead({
          title: siteTitle,
        });
      }
      
      // 设置页面描述
      const pageDescription = siteInfo.description || siteTitle;
      if (pageDescription) {
        useHead({
          meta: [
            {
              hid: "description",
              name: "description",
              content: pageDescription,
            },
          ],
        });
      }

       // 设置站点图标（优先 SITE_ICON，带兜底）
    const siteIcon =
    configData?.SITE_ICON ||
    configData?.pc_SITE_ICON ||
    configData?.favicon ||
    configData?.icon ||
    configData?.logoUrl;

    if (siteIcon) {
      useHead({
        link: [
          { rel: "icon", type: "image/png", href: siteIcon },
          { rel: "shortcut icon", href: siteIcon },
          { rel: "apple-touch-icon", href: siteIcon },
        ],
      });
    }
    }

    try {
      resAll = await withDevelopmentTimeout(
        getActiveDetail(
          {
            id: id || route.query.id,
            url: url || route.query.url,
            pageNo: 0,
            pageSize: 1,
          },
          $fetch,
          headers
        )
      );
    } catch (e) {
      if (process.env.NODE_ENV === "development") {
        console.warn(
          "Error fetching active page config, using empty development page:",
          e?.message || e
        );
        resolve(createEmptyActiveDetailData());
        return;
      }
      console.error(e);
    }
  
    
    const res = resAll.data;
    let allArcListMap = {};
    let allGoodsListMap = {};
    let pages = [];
    const resMakeData = await makeAllArcListMap(
      $fetch,
      headers,
      res,
      allArcListMap,
      pages
    );

    // 获取商品列表数据
    const resGoodsData = await makeAllGoodsListMap(
      $fetch,
      headers,
      resMakeData.pages,
      allGoodsListMap
    );

    const currentPageConfig =
      (resMakeData.pages && resMakeData.pages[currentPageIndex.value]) || null;

    resolve({
     
      currentPageConfig,
      pages: resMakeData.pages,
      allArcListMap: resMakeData.allArcListMap,
      allGoodsListMap: resGoodsData.allGoodsListMap,
    });
  });
}
